import { Link } from 'react-router-dom';
import { ArrowRight, Phone, CheckCircle } from 'lucide-react';

const CTASection = () => {
  const benefits = [
    'Free, no-obligation estimates',
    'Fully licensed and insured',
    'Local Calgary contractor',
    'Clear timelines and communication',
  ];

  return (
    <section className="py-24 md:py-32 bg-[#0f172a] relative overflow-hidden" data-testid="cta-section">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
          <rect width="100" height="100" fill="url(#grid)" />
        </svg>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <p className="text-[#c5a059] text-sm uppercase tracking-[0.3em] mb-4">
              Start Your Project
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-6">
              Ready to Transform Your Home?
            </h2>
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              Whether you're planning a basement development, bathroom renovation, or custom 
              feature installation, we're here to bring your vision to life with quality 
              craftsmanship you can trust.
            </p>
            
            {/* Benefits */}
            <ul className="space-y-4 mb-10">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3 text-white">
                  <CheckCircle size={20} className="text-[#c5a059] flex-shrink-0" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="group inline-flex items-center justify-center gap-3 bg-[#c5a059] text-[#0f172a] px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-white transition-all duration-300"
                data-testid="cta-estimate-button"
              >
                Request Free Estimate
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <a
                href="tel:403-402-6596"
                className="group inline-flex items-center justify-center gap-3 border-2 border-white/30 text-white px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:border-white hover:bg-white hover:text-[#0f172a] transition-all duration-300"
                data-testid="cta-call-button"
              >
                <Phone size={18} />
                403-402-6596
              </a>
            </div>
          </div>

          {/* Right - Service Areas */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-10">
            <h3 className="font-heading text-2xl font-semibold text-white mb-6">
              Serving Calgary & Surrounding Areas
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {['Calgary', 'Airdrie', 'Cochrane', 'Chestermere', 'Okotoks'].map((area) => (
                <div
                  key={area}
                  className="flex items-center gap-2 text-slate-300"
                  data-testid={`service-area-${area.toLowerCase()}`}
                >
                  <div className="w-2 h-2 bg-[#c5a059] rounded-full" />
                  <span>{area}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 pt-8 border-t border-white/10">
              <p className="text-slate-400 text-sm">
                Not sure if we serve your area? Give us a call and we'll let you know!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
